import { createSelector } from '@ngrx/store';
import { getRewardsPreferenceFeatureState } from '../reducers';
import { RewardsPreferenceState } from '../reducers/rewards-preference.reducer';

export const getRewardsPreference = createSelector(
  getRewardsPreferenceFeatureState,
  (state: RewardsPreferenceState) => state.rewardsPreference,
);

export const getLoadRewardsPreferenceLoading = createSelector(
  getRewardsPreferenceFeatureState,
  (state: RewardsPreferenceState) => state.getRewardsPreference.loading,
);

export const getLoadRewardsPreferenceSuccess = createSelector(
  getRewardsPreferenceFeatureState,
  (state: RewardsPreferenceState) => state.getRewardsPreference.success,
);

export const getLoadRewardsPreferenceError = createSelector(
  getRewardsPreferenceFeatureState,
  (state: RewardsPreferenceState) => state.getRewardsPreference.error,
);

export const getCreateRewardsPreferenceLoading = createSelector(
  getRewardsPreferenceFeatureState,
  (state: RewardsPreferenceState) => state.createRewardsPreference.loading,
);

export const getCreateRewardsPreferenceSuccess = createSelector(
  getRewardsPreferenceFeatureState,
  (state: RewardsPreferenceState) => state.createRewardsPreference.success,
);

export const getCreateRewardsPreferenceError = createSelector(
  getRewardsPreferenceFeatureState,
  (state: RewardsPreferenceState) => state.createRewardsPreference.error,
);
